<template>
  <el-dialog
    top="70px"
    :width="customWidth"
    append-to-body
    :visible.sync="pokaziNovPopup"
    :fullscreen="$screen.breakpoint === 'xs' || $screen.breakpoint === 'sm'"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="spremembaStoritevDialog"
  >
    <template v-slot:title>
      <slot name="title">
        <div class="d-flex">
          <div class="open-sans-20pt" style="flex:auto;">{{title}}</div>
          <div @click="closePopup()"><el-icon class="el-icon-close" style="font-size: 24px; cursor: pointer;"/></div>
        </div>
      </slot>
    </template>
    <template v-slot:default>
      <div style="text-align: justify;word-break: break-word;">
        Spremenili boste nabor naročenih storitev. V predogled ste prejeli pogodbene dokumente. Pred oddajo zahteve za spremembo jih prosimo pozorno preglejte.
      </div>
      <sprememba-storitev-component
        :services="services"
        :cancel-order="cancelOrder"
        :serviceName="serviceName"
        :lowerQuantity="lowerQuantity"
        @notificationClose="orderConfirmed = true; pokaziNovPopup = false"
      />
    </template>
  </el-dialog>
</template>

<script>
import {Dialog, Button} from 'element-ui'
import SpremembaStoritevComponent from './SpremembaStoritevComponent.vue'

export default {
  name: 'SpremembaStoritevPopup',
  components: {
    SpremembaStoritevComponent,
    [Dialog.name]: Dialog,
    [Button.name]: Button
  },
  emits: ['zapriPopup', 'orderConfirmed'],
  props: {
    services: {
      type: Array,
      required: true
    },
    serviceName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Predogled pogodbenih dokumentov'
    },
    lowerQuantity: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pokaziNovPopup: true,
      cancelOrder: false,
      orderConfirmed: false
    }
  },
  computed: {
    customWidth () {
      let out = '1000px'
      switch (this.$screen.breakpoint) {
        case 'xs':
          out = '550px'
          break
        case 'sm':
          out = '600px'
          break
        case 'md':
          out = '700px'
          break
        case 'lg':
          out = '900px'
          break
        case 'xl':
          out = '1100px'
          break
      }
      return out
    }
  },
  methods: {
    closePopup () {
      this.cancelOrder = true
      setTimeout(() => {
        this.pokaziNovPopup = false
      }, 200)
    }
  },
  watch: {
    pokaziNovPopup (val) {
      if (val === false) {
        if (!this.orderConfirmed) {
          this.cancelOrder = true
        } else {
          this.$emit('orderConfirmed')
        }
        setTimeout(() => {
          this.$emit('zapriPopup')
        }, 200)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/SpremembaStoritevPopup.vue